import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import t from "../../../Graphic.js";
import { w as o } from "../../../chunks/languageUtils.js";
import r from "../../../core/Accessor.js";
import { HandleOwnerMixin as n } from "../../../core/HandleOwner.js";
import { throttle as s } from "../../../core/throttle.js";
import { init as i } from "../../../core/watchUtils.js";
import { property as l } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as p } from "../../../core/accessorSupport/decorators/subclass.js";
import "../../../popup/content/AttachmentsContent.js";
import "../../../popup/content/Content.js";
import "../../../popup/content/CustomContent.js";
import "../../../popup/content/ExpressionContent.js";
import a from "../../../popup/content/FieldsContent.js";
import c from "../../../popup/content/MediaContent.js";
import m from "../../../popup/content/TextContent.js";
import d from "../../../popup/ElementExpressionInfo.js";
import u from "../FeatureContent/FeatureContentViewModel.js";
import h from "../FeatureFields/FeatureFieldsViewModel.js";
import f from "../FeatureMedia/FeatureMediaViewModel.js";
import { loadArcadeUtils as _, createCompiledExpression as v } from "../support/arcadeFeatureUtils.js";
var w = 1;

var y = /*#__PURE__*/function (_n) {
  _inherits(y, _n);

  var _super = _createSuper(y);

  function y(e) {
    var _this;

    _classCallCheck(this, y);

    _this = _super.call(this, e), _this._abortController = null, _this.expressionInfo = null, _this.graphic = null, _this.contentElement = null, _this.contentElementViewModel = null, _this.interceptor = null, _this.view = null, _this._cancelQuery = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          e = _assertThisInitialize._abortController;

      e && e.abort(), _this._abortController = null;
    }, _this._createVM = function () {
      var e, t;
      var o = null == (e = _this.contentElement) ? void 0 : e.type;
      null == (t = _this.contentElementViewModel) || t.destroy();
      var r = "fields" === o ? new h() : "media" === o ? new f() : "text" === o ? new u() : null;

      _this._set("contentElementViewModel", r);
    }, _this._compile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var e;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this._cancelQuery();

              e = new AbortController();
              _this._abortController = e;
              _context.next = 5;
              return _this._compileExpression();

            case 5:
              _this._abortController === e && (_this._abortController = null);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this._compileThrottled = s(_this._compile, w, _assertThisInitialized(_this)), _this._compileExpression = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _assertThisInitialize2, e, t, r, n, s, i, l, p, d, u, h, f;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _assertThisInitialize2 = _assertThisInitialized(_this), e = _assertThisInitialize2.expressionInfo, t = _assertThisInitialize2.graphic, r = _assertThisInitialize2.interceptor, n = _assertThisInitialize2.spatialReference, s = _assertThisInitialize2.map, i = _assertThisInitialize2.view, l = _assertThisInitialize2._abortController;

              if (e && t && n && s && i) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", void _this._set("contentElement", null));

            case 3:
              _context2.next = 5;
              return _();

            case 5:
              p = _context2.sent;

              if (!(l !== _this._abortController)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              _context2.next = 10;
              return v({
                arcadeUtils: p,
                expressionInfo: e,
                graphic: t,
                interceptor: r,
                map: s,
                spatialReference: n,
                view: i
              });

            case 10:
              d = _context2.sent;

              if (!(!d || "esri.arcade.Dictionary" !== d.declaredClass)) {
                _context2.next = 13;
                break;
              }

              return _context2.abrupt("return", void _this._set("contentElement", null));

            case 13:
              _context2.next = 15;
              return o(d, l.signal);

            case 15:
              u = _context2.sent;
              h = null == u ? void 0 : u.type;
              f = "media" === h ? c.fromJSON(u) : "text" === h ? m.fromJSON(u) : "fields" === h ? a.fromJSON(u) : null;

              _this._set("contentElement", f);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), _this.handles.add([i(_assertThisInitialized(_this), ["expressionInfo", "graphic", "map", "spatialReference", "view"], _this._compileThrottled), i(_assertThisInitialized(_this), "contentElement", _this._createVM)]);
    return _this;
  }

  _createClass(y, [{
    key: "destroy",
    value: function destroy() {
      var e;
      this._cancelQuery(), null == (e = this.contentElementViewModel) || e.destroy(), this._set("contentElementViewModel", null), this._set("contentElement", null);
    }
  }, {
    key: "spatialReference",
    get: function get() {
      var e;
      return (null == (e = this.view) ? void 0 : e.spatialReference) || null;
    },
    set: function set(e) {
      void 0 !== e ? this._override("spatialReference", e) : this._clearOverride("spatialReference");
    }
  }, {
    key: "state",
    get: function get() {
      var e = this._abortController,
          t = this.contentElement,
          o = this.contentElementViewModel;
      return e ? "loading" : t || o ? "ready" : "disabled";
    }
  }, {
    key: "map",
    get: function get() {
      var e;
      return (null == (e = this.view) ? void 0 : e.map) || null;
    },
    set: function set(e) {
      void 0 !== e ? this._override("map", e) : this._clearOverride("map");
    }
  }]);

  return y;
}(n(r));

e([l()], y.prototype, "_abortController", void 0), e([l({
  type: d
})], y.prototype, "expressionInfo", void 0), e([l({
  type: t
})], y.prototype, "graphic", void 0), e([l({
  readOnly: !0
})], y.prototype, "contentElement", void 0), e([l({
  readOnly: !0
})], y.prototype, "contentElementViewModel", void 0), e([l()], y.prototype, "interceptor", void 0), e([l()], y.prototype, "spatialReference", null), e([l({
  readOnly: !0
})], y.prototype, "state", null), e([l()], y.prototype, "map", null), e([l()], y.prototype, "view", void 0), y = e([p("esri.widgets.Feature.FeatureExpression.FeatureExpressionViewModel")], y);
var j = y;
export { j as default };